import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components/macro';
import { MessageStateProps } from './message-state.types';
import { IconVariants } from './message-state.constants';
import { SVG } from 'components';
import { Icons } from 'assets';

export const MessageState: FC<MessageStateProps> = observer(
  ({ state, isLoading, isSummary }) => {
    const theme = useTheme();

    if (isLoading) {
      return (
        <SVG
          src={Icons.Timer}
          props={{
            color: theme.colors.gray[400],
          }}
        />
      );
    }

    return (
      <SVG
        src={IconVariants[state]}
        props={{
          color:
            state === 'read' && !isSummary
              ? theme.colors.primary[600]
              : theme.colors.gray[400],
        }}
      />
    );
  }
);
